var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "coupon-box mdc-typography mdc-typography mdc-typography--body2"
    },
    [
      _c("separator"),
      _vm._v(" "),
      _c("div", { staticClass: "coupon-box__content" }, [
        _c("div", { staticClass: "coupon-box__content__title" }, [
          _vm._v(_vm._s(_vm.$t("COUPON.TITLE")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "coupon-box__content__code" }, [
          _c("span", [_vm._v(_vm._s(_vm.coupon))]),
          _vm._v(" "),
          _vm.valid
            ? _c(
                "i",
                {
                  staticClass:
                    "material-icons mdc-text-field__icon mdc-text-field__icon--trailing"
                },
                [_vm._v("check")]
              )
            : _c(
                "i",
                {
                  staticClass:
                    "material-icons invalid mdc-text-field__icon mdc-text-field__icon--trailing"
                },
                [_vm._v("cancel")]
              )
        ]),
        _vm._v(" "),
        !_vm.valid
          ? _c("div", { staticClass: "coupon-box__content__invalid" }, [
              _vm._v(_vm._s(_vm.$t("COUPON.INVALID")))
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }